<template>
    <div class="bootstrapTableContainer">
        <h3>BootStrap Table Sample</h3>
        <b-table
          id="table"
          :fields="fields"
          :items="getUser"
          :per-page="perPage"
          :current-page="currentPage"
          @row-clicked="onRowClicked"
          striped hover>
          </b-table>
          <b-pagination
          v-model="currentPage"
          :total-rows="totalCnt"
          :per-page="perPage"
          aria-controls="table">
        </b-pagination>
        
    </div>
</template>

<script>
import axios from 'axios'

export default {
  components:{
  },
  name: 'BootStrapTableSample',
  data() {
    return {
      perPage: 4,
      currentPage: 1,
      totalCnt: 0,
      sortBy: 'IDX',
      sortDesc: false,
      searchText : "",
      fields: [
        {
          key: 'ID',
          sortable: false
        },
        {
          key: 'EMAIL',
          sortable: false
        },
        {
          key: 'NAME',
          label: 'Person age',
          sortable: false,
          variant: 'danger'
        }
      ]
    }
  },
  methods:{
    getUser(){
      return axios
        .post('http://localhost:8080/test/getUser', {
          currentPage: this.currentPage,
          perPage: this.perPage,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          searchText : this.searchText 
        })
        .then(response => {
          const items = response.data.items
          this.totalCnt = response.data.totalCnt

          return items
        })
        .catch(error => {
          console.log("error: "+error)
          return []
        })
    },
    onRowClicked(item){
      let paramDatas = { idx : item.IDX }
      /* this.$popup("사용자 상세보기", "views/common/popup/DetailUser.vue", "VIEW", paramDatas, false); */
      this.$popup("사용자 수정하기", "views/common/popup/WriteUser.vue", "MOD", paramDatas, false);
    }    
  }
}
</script>

<style scoped lang="scss">
  .bootstrapTableContainer ::v-deep {
    @import "~bootstrap/dist/css/bootstrap.min";
  }
</style>